 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A780743273251_COV from '@/components/9780743273251_cov'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import A780743273251_ADCARDPAGE_01 from '@/components/9780743273251_adCardPage_01'
 import A780743273251_TITLEPAGE_01 from '@/components/9780743273251_titlePage_01'
 import A780743273251_COP from '@/components/9780743273251_cop'
 import A780743273251_DP from '@/components/9780743273251_dp'
 import A780743273251_FM1 from '@/components/9780743273251_fm1'
 import A780743273251_HALFTITLEPAGE_01 from '@/components/9780743273251_halfTitlePage_01'
 import A780743273251_CON from '@/components/9780743273251_con'
 import A780743273251_FM2 from '@/components/9780743273251_fm2'
 import A780743273251_P1 from '@/components/9780743273251_p1'
 import A780743273251_CH1 from '@/components/9780743273251_ch1'
 import A780743273251_CH2 from '@/components/9780743273251_ch2'
 import A780743273251_CH3 from '@/components/9780743273251_ch3'
 import A780743273251_CH4 from '@/components/9780743273251_ch4'
 import A780743273251_CH5 from '@/components/9780743273251_ch5'
 import A780743273251_CH6 from '@/components/9780743273251_ch6'
 import A780743273251_CH7 from '@/components/9780743273251_ch7'
 import A780743273251_CH8 from '@/components/9780743273251_ch8'
 import A780743273251_CH9 from '@/components/9780743273251_ch9'
 import A780743273251_CH10 from '@/components/9780743273251_ch10'
 import A780743273251_P2 from '@/components/9780743273251_p2'
 import A780743273251_CH11 from '@/components/9780743273251_ch11'
 import A780743273251_CH12 from '@/components/9780743273251_ch12'
 import A780743273251_CH13 from '@/components/9780743273251_ch13'
 import A780743273251_CH14 from '@/components/9780743273251_ch14'
 import A780743273251_CH15 from '@/components/9780743273251_ch15'
 import A780743273251_CH16 from '@/components/9780743273251_ch16'
 import A780743273251_CH17 from '@/components/9780743273251_ch17'
 import A780743273251_BM1 from '@/components/9780743273251_bm1'
 import A780743273251_BM2 from '@/components/9780743273251_bm2'
 import A780743273251_END from '@/components/9780743273251_end'
 import A780743273251_BM3 from '@/components/9780743273251_bm3'
 import A780743273251_BM4 from '@/components/9780743273251_bm4'
 import A780743273251_PHOTO from '@/components/9780743273251_photo'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9780743273251_con",
 			"name" : "9780743273251_con",
 			"component" : A780743273251_CON
 		},
 		{
 			"path" : "/9780743273251_fm2",
 			"name" : "9780743273251_fm2",
 			"component" : A780743273251_FM2
 		},
 		{
 			"path" : "/9780743273251_p1",
 			"name" : "9780743273251_p1",
 			"component" : A780743273251_P1
 		},
 		{
 			"path" : "/9780743273251_ch1",
 			"name" : "9780743273251_ch1",
 			"component" : A780743273251_CH1
 		},
 		{
 			"path" : "/9780743273251_ch2",
 			"name" : "9780743273251_ch2",
 			"component" : A780743273251_CH2
 		},
 		{
 			"path" : "/9780743273251_ch3",
 			"name" : "9780743273251_ch3",
 			"component" : A780743273251_CH3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js